import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import './index.css';

function installAhrefsWebAnalytics() {
  const dataKey = import.meta.env.VITE_AHREFS_WEB_ANALYTICS_KEY?.trim();
  if (!dataKey) return;

  const existingScript = document.querySelector<HTMLScriptElement>(
    'script[data-ahrefs-web-analytics="true"]'
  );
  if (existingScript) return;

  const script = document.createElement('script');
  script.src = 'https://analytics.ahrefs.com/analytics.js';
  script.defer = true;
  script.setAttribute('data-key', dataKey);
  script.setAttribute('data-ahrefs-web-analytics', 'true');
  document.head.appendChild(script);
}

installAhrefsWebAnalytics();

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    enableLogs: true,
    tracesSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
      }),
      Sentry.consoleLoggingIntegration({
        levels: ['log', 'info', 'warn', 'error', 'debug', 'assert', 'trace'],
      }),
    ],
    // Record every session for maximum insights
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
